export default "__VITE_ASSET__Bzck5OK4__"